import { useState } from 'react';
import { BrowserRouter, RouteComponentProps } from 'react-router-dom';
import { useFullscreenModal } from '../../models/hooks/appStateHooks';
import { Button } from '../../web/components-v2/Button';
import {
	Content,
	StaticDrawer,
	StickyContent,
	Toolbar,
	ToolbarButton,
} from '../../web/components-v2/Drawer/static/AppDrawer';
import { Column, Row } from '../../web/components-v2/PageLayout';
import { WebFullscreenModal } from '../../web/components/fullscreen/WebFullscreenModal';
import { HomeIcon } from '../../web/components/svgs/icons/HomeIcon';
import { SettingsIcon } from '../../web/components/svgs/icons/SettingsIcon';
import { TableSettingsIcon } from '../../web/components/svgs/icons/TableSettingsIcon';
import { bs } from '../../web/styles/styles';

export const StaticDrawerExamples = () => {
	const fullscreenModal = useFullscreenModal();

	const openFullscreenDemo = () => {
		fullscreenModal.history.push({ pathname: '/demo/static-drawer' });
	};

	return (
		<BrowserRouter>
			<Row styles={[bs.gap4, bs.p2]}>
				<Button variant='primary' onClick={openFullscreenDemo}>
					Open Fullscreen Demo
				</Button>
			</Row>
			<WebFullscreenModal />
		</BrowserRouter>
	);
};

export const DemoContent = (_props: RouteComponentProps<any>) => {
	const [activeDrawerTab, setActiveDrawerTab] = useState('tab-1');

	return (
		<Row>
			<Column fullWidth />
			<StaticDrawer value={activeDrawerTab} onValueChange={setActiveDrawerTab}>
				<Content value='tab-1' onValueChange={setActiveDrawerTab}>
					<h2>Tab 1</h2>
				</Content>
				<Content value='tab-2' onValueChange={setActiveDrawerTab}>
					<h2>Tab 2</h2>
				</Content>
				<StickyContent value='tab-3' onValueChange={setActiveDrawerTab}>
					<div style={{ padding: 24 }}>
						<h2>Tab 3 (Sticky)</h2>
					</div>
				</StickyContent>
				<Toolbar>
					<ToolbarButton value='tab-1' onValueChange={setActiveDrawerTab} tooltip='Tab 1'>
						<HomeIcon stroke='currentColor' />
					</ToolbarButton>
					<ToolbarButton value='tab-2' onValueChange={setActiveDrawerTab} tooltip='Tab 2'>
						<SettingsIcon stroke='currentColor' />
					</ToolbarButton>
					<ToolbarButton value='tab-3' onValueChange={setActiveDrawerTab} tooltip='Tab 3'>
						<TableSettingsIcon />
					</ToolbarButton>
				</Toolbar>
			</StaticDrawer>
		</Row>
	);
};
